import React from 'react';
import DigitizationMetadata from "../DigitizationMetadata";
import {DigitizationDetailsSidebarWrapper, StyledVerificationInfo} from "./DigitizationDetailsSidebar.styled";
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import DigitizationDocumentCategory from "../DigitizationDocumentCategory";
import DigitizationFileActivityLog from "../DigitizationFileActivityLog";
import {
    LocalDocumentCategory,
    LocalDocumentContentResponse,
    LocalDocumentHistoryResponse
} from "../../../../../models/local-documents.models";
import {formatDateWithLanguageToOnlyDate} from "../../../../../utils/format-date";
import {useTranslation} from "react-i18next";

interface DigitizationDetailsSidebarProps {
    document: LocalDocumentContentResponse;
    history: LocalDocumentHistoryResponse[];
    onDocumentCategoryChange: (category: LocalDocumentCategory) => Promise<void>;
}

const DigitizationDetailsSidebar = ({document, history, onDocumentCategoryChange}: DigitizationDetailsSidebarProps) => {
    const {t} = useTranslation();

    const metadata = [
        {
            label: t('digitizationDetails.metadata.documentId'),
            value: document.documentId ?? '\u2014'
        },
        {
            label: t('digitizationDetails.metadata.packageId'),
            value: document.packageId ?? '\u2014'
        },
        {
            label: t('digitizationDetails.metadata.sourceLanguage'),
            value: document.sourceLanguage ? document.sourceLanguage.toUpperCase() : '\u2014'
        },
        {
            label: t('digitizationDetails.metadata.fileFormat'),
            value: document.fileFormat ? document.fileFormat.toUpperCase() : '\u2014'
        },
        {
            label: t('digitizationDetails.metadata.sentBy'),
            value: document.sentBy ?? '\u2014'
        },
        {
            label: t('digitizationDetails.metadata.verifiedOn'),
            value: document.verifiedAt ? formatDateWithLanguageToOnlyDate(document.verifiedAt) : '\u2014'
        },
        {
            label: t('digitizationDetails.metadata.verifiedBy'),
            value: (
                document.verifiedBy ? (
                    <StyledVerificationInfo>
                        <CheckCircleOutlineRoundedIcon sx={{ fontSize: '20px', color: "#22C55E" }} /> {document.verifiedBy}
                    </StyledVerificationInfo>
                )
                : '\u2014'
            ),
        },
    ];

    return (
        <DigitizationDetailsSidebarWrapper>
            <DigitizationMetadata dataRows={metadata} />

            <DigitizationDocumentCategory
                category={document.type as LocalDocumentCategory}
                onChange={onDocumentCategoryChange}
            />

            <DigitizationFileActivityLog history={history} fileName={document.fileName} />
        </DigitizationDetailsSidebarWrapper>
    );
};

export default DigitizationDetailsSidebar;